import { useQuery } from '@tanstack/react-query';

import { listQuotedCommissions } from '~/services/AgentHub/AgentService';

import { ListQuotedCommissionsParams } from '~/types/services/agentHub';

export const quotedCommissionQueryKeys = {
  all: ['quoted-commissions'] as const,
  lists: () => [...quotedCommissionQueryKeys.all, 'list'] as const,
  list: (params: ListQuotedCommissionsParams) => [...quotedCommissionQueryKeys.lists(), params] as const,
};

export function useListQuotedCommissions(params: ListQuotedCommissionsParams) {
  return useQuery({
    placeholderData: (prev) => {
      return {
        rows: prev?.rows ?? [],
        total: prev?.total ?? 0,
      };
    },
    queryKey: quotedCommissionQueryKeys.list(params),
    queryFn: async () => {
      return await listQuotedCommissions(params);
    },
  });
}
